import { Injectable, inject } from '@angular/core'
import { ProductWrapping } from '@tradecafe/types/core'
import { pick } from 'lodash-es'
import { AuthApiService } from 'src/api/auth'
import { ProductWrappingApiService } from 'src/api/product/wrapping'

const ALLOWED_FIELDS = ['name', 'description', 'attributes']
const CACHE_MAX_AGE = 3600 * 1000 // 1hr


/**
 * WrappingTypes service
 *
 * @export
 * @returns
 */
@Injectable()
export class WrappingTypesService {
  private AuthApi = inject(AuthApiService)
  private ProductWrappingApi = inject(ProductWrappingApiService)



  private cacheExpiration = 0
  private cache = Promise.resolve({ data: [] })

  /**
   * Get all available wrapping-types
   *
   * @param {any} query
   * @returns {Object} { total_rows:number, data: []}
   */
  async getWrappingTypes() {
    if (!this.cache || this.cacheExpiration < Date.now()) {
      this.cacheExpiration = Date.now() + CACHE_MAX_AGE // 1 min
      // NOTE: we fetch everything
      this.cache = this.ProductWrappingApi.list({ limit: Number.MAX_SAFE_INTEGER })
      .then(async (wrappingTypes) => {
        wrappingTypes.data.forEach(wrappingType => {
          wrappingType.updated = wrappingType.updated || wrappingType.created
        })
        return wrappingTypes
      })
      .catch((err) => {
        this.invalidateCache()
        throw err
      })
    }
    const { data } = await this.cache
    return data
  }

  /**
   * Create new wrappingType
   *
   * @param {any} wrappingType
   * @returns
   */
  async create(wrappingType) {
    const payload = pick(wrappingType, ALLOWED_FIELDS)
    const { user_id } = this.AuthApi.currentUser
    payload.user_id = user_id

    const { data } = await this.ProductWrappingApi.create(payload)
    this.invalidateCache()
    return data
  }

  /**
   * Update wrappingType
   *
   * @param {any} wrappingType
   * @returns
   */
  async update(wrappingType: Partial<ProductWrapping>) {
    const { wrapping_id } = wrappingType
    const payload = pick(wrappingType, ALLOWED_FIELDS)
    const { user_id } = this.AuthApi.currentUser
    payload.user_id = user_id

    const { data } = await this.ProductWrappingApi.update(wrapping_id, payload)
    this.invalidateCache()
    return data
  }

  /**
   * Update wrappingType
   *
   * @param {any} wrappingType
   * @returns
   */
  async remove(wrapping_id: string) {
    const { data } = await this.ProductWrappingApi.delete(wrapping_id)
    this.invalidateCache()
    return data
  }


  /**
   * Invalidate wrapping-types in-memory cache
   *
   * @private
   */
  private invalidateCache() {
    this.cacheExpiration = 0
  }
}
